import { useState, useEffect, useContext } from "react";
import { Route, Link, Routes, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { IoMdArrowDropdown, IoMdArrowDropleft } from "react-icons/io";
import { RiMenu3Fill, RiCloseFill } from "react-icons/ri";
import { SlEarphonesAlt } from "react-icons/sl";
import { FaFacebookF, FaSearch, FaRegUser } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import { AppContext } from "../Context";
import { Img, UserLoginSection } from "../components/Elements";

import Logo from "../assets/logo_white.png";

import "./css/Header.css";

export default function Header({ main, article }) {
    const { t } = useTranslation();
    let route = useLocation();
    var style = window.getComputedStyle(document.body);

    const { userData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;

    const [menu, setmenu] = useState(false);
    const [effect, seteffect] = useState({});

    useEffect(() => {
        seteffect((p) => ({
            ...p,
            a: "open",
        }));

        setTimeout(() => {
            seteffect((p) => ({
                ...p,
                p: "open",
            }));
        }, 500);

        setTimeout(() => {
            seteffect((p) => ({
                ...p,
                h2: "open",
            }));
        }, 1000);

        setTimeout(() => {
            seteffect((p) => ({
                ...p,
                h1: "open",
            }));
        }, 1500);
    }, []);

    return (
        <>
            <header className={`${main ? "main" : "mope"}`}>
                <div className="logoBox">
                    <div className="mainWidth">
                        <div className="f1">
                            <img className="logo" src={Logo} />

                            <div className="phoneNumberBox">
                                <p>
                                    <SlEarphonesAlt />
                                    <span>050-777-0313</span>
                                </p>
                                <b>تواصلوا معنا بسرعة من هنا</b>
                            </div>
                        </div>

                        <div className="f2">
                            {/* <a tabindex="0" className='headMainBtns'>
                                <FaFacebookF />
                                فيسبوك
                            </a>
                            <a tabindex="0" className='headMainBtns'>
                                <FaXTwitter />
                                اكس
                            </a> */}
                            {/* <a tabindex="0" className='headMainBtns'>
                                <FaSearch />
                                ابحث
                            </a> */}
                            {userinfo?._id ? (
                                <UserLoginSection />
                            ) : (
                                <Link
                                    tabindex="0"
                                    className="headMainBtns"
                                    to="/login"
                                    state={{ previousLocation: route }}
                                    style={{
                                        color: style.getPropertyValue(
                                            "--orange",
                                        ),
                                    }}
                                >
                                    <FaRegUser />
                                    الدخول
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                {!main && (
                    <div className="menuBox">
                        <div className="mainWidth">
                            <a
                                onClick={() => setmenu((p) => !p)}
                                className="mobile menuIconBox"
                            >
                                <RiMenu3Fill />
                            </a>

                            <nav className={menu ? "open" : "closed"}>
                                <a
                                    onClick={() => setmenu((p) => !p)}
                                    className="mobile closeMenu"
                                >
                                    <RiCloseFill />
                                </a>
                                <li className="parent selected">
                                    <a href="#">البيت</a>
                                </li>
                                <li className="parent">
                                    <a href="#">
                                        Music land+ <IoMdArrowDropdown />
                                    </a>
                                    <ul>
                                        <div>
                                            <a href="#">
                                                <IoMdArrowDropleft /> قسم ١sssss
                                            </a>
                                            <a href="#">
                                                <IoMdArrowDropleft /> قسم ٢
                                            </a>
                                            <a href="#">
                                                <IoMdArrowDropleft /> قسم ٣
                                            </a>
                                            <a href="#">
                                                <IoMdArrowDropleft /> قسم ٤
                                            </a>
                                        </div>
                                    </ul>
                                </li>
                                <li className="parent">
                                    <a href="#">اغاني مدرسية</a>
                                </li>
                                <li className="parent">
                                    <a href="#">الدروس</a>
                                </li>
                                <li className="parent">
                                    <a href="#">عن البرنامج</a>
                                </li>
                                <li className="parent">
                                    <a href="#">تواصلوا معنا</a>
                                </li>
                            </nav>
                        </div>
                    </div>
                )}
            </header>

            {main && article?.title ? (
                <div className="effectBox">
                    <div className="blend"></div>

                    <div className="mainWidth open">
                        <div className="textEffect">
                            <h1 className={effect?.h1 ? effect?.h1 : "closed"}>
                                {article?.title}
                            </h1>
                            <h2 className={effect?.h2 ? effect?.h2 : "closed"}>
                                {article?.sub_title}
                            </h2>
                            <p className={effect?.p ? effect?.p : "closed"}>
                                {article?.short}
                            </p>

                            {/* <a className={`btn ${effect?.a ? effect?.a : 'closed'}`}>اقرأ المزيد</a> */}
                        </div>
                    </div>
                </div>
            ) : (
                false
            )}
        </>
    );
}
